import { render, staticRenderFns } from "./taskAllocationModal.vue?vue&type=template&id=4c0b7f06"
import script from "./taskAllocationModal.vue?vue&type=script&lang=js"
export * from "./taskAllocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports